module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-support-buttons-item-bg-1-sp-8d5ad454b05d6a16dc74220e7b7dd7d0.png";